import { useHotelInfoOfHotelPolicy } from "./hooks";
import { QuestionHotelInfo } from "../../../../../../../_shared/components/main/question/hotel-info/root";

export const QuestionHotelPolicyHotelInfo = () => {
	const {
		hotelInfo,
		append,
		removeHotelInfoByIndex,
		reorderHotelInfo,
		updateTitle,
		updateDescription,
	} = useHotelInfoOfHotelPolicy();

	return (
		<QuestionHotelInfo
			hotelInfo={hotelInfo}
			appendHotelInfo={append}
			removeHotelInfo={removeHotelInfoByIndex}
			reorderHotelInfo={reorderHotelInfo}
			changeHotelInfoTitle={updateTitle}
			changeHotelInfoDescription={updateDescription}
		/>
	);
};

QuestionHotelPolicyHotelInfo.displayName = "QuestionHotelPolicyHotelInfo";
